<template>
    <PageContainer>
        <PageHeader>
            {{ $t('product.index.page_title') }}

            <template #right>
                <CreateButton class="btn-sm" href="/products/create" />
            </template>
        </PageHeader>

        <SearchPanel
            :search="search"
            url="/products"
            :only="['products', 'search']"
        />

        <base-table>
            <template #thead>
                <th>{{ $t('product.name') }}</th>
                <th>{{ $t('product.size_type') }}</th>
                <th>{{ $t('product.size_count') }}</th>
                <th>{{ $t('product.total_quantity') }}</th>
            </template>
            <tr v-for="product in pagination.data" class="align-middle">
                <td>{{ product.name }}</td>
                <td>{{ product.size_type }}</td>
                <td>{{ product?.sizes_count || 0 }}</td>
                <td>{{ getRemainingStock(product?.stocks) }}</td>
            </tr>
        </base-table>

        <Pagination
            :pagination="pagination.pagination"
        />
    </PageContainer>
</template>

<script setup lang="ts">
import BaseTable from "@/components/elements/BaseTable.vue";
import Pagination from "@/components/elements/Pagination.vue";
import type {PaginatedResponse, ProductInterface, StockInterface} from "@/components/helpers/Interfaces.ts";
import {usePagination} from "@/Composable/usePagination.ts";
import PageHeader from "@/components/elements/PageHeader.vue";
import PageContainer from "@/components/elements/PageContainer.vue";
import SearchPanel from "@/components/elements/SearchPanel.vue";
import CreateButton from "@/components/buttons/CreateButton.vue";

const { products, search = null } = defineProps<{
    products: PaginatedResponse<ProductInterface>,
    search: string
}>()

const pagination = usePagination<ProductInterface>(products)

const getRemainingStock = (stocks: StockInterface[]) => {
    let total = 0
    stocks
        .map(stock => {
            total += stock.remaining_quantity
        })
    return total
}
</script>

<style scoped>

</style>
